import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-hot-toast';
import Btn from '../global/Btn';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../auth/useAuthContext';
import { countries } from '../../constants/countres';
import FormInput from '../inputs/FormInput';

const FormRegister = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [selectedCountryCode, setSelectedCountryCode] = useState(countries[0].phone);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const NewRegisterSchema = Yup.object().shape({
        name: Yup.string(),
        email: Yup.string(),
        phone: Yup.string(),
        password: Yup.string(),
        confirmPassword: Yup.string(),
    });

    const { handleSubmit, reset } = useForm({
        resolver: yupResolver(NewRegisterSchema),
    });
    // const form = useRef();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { register } = useAuthContext();
    // const country = countries.find(c => c.phone === selectedCountryCode);
    const fullPhoneNumber = `0${phoneNumber}`;

    const SubmitForm = async () => {

        setLoading(true)
        try {
            if (password !== confirmPassword) {
                toast.error("Passwords do not match");
                setLoading(false);
                return;
            }
            const result = await register(name, email, fullPhoneNumber, password, confirmPassword, 'general_admin');
            console.log("🚀 ~ SubmitForm ~ result:", result)
            if (result.status === 201) {
                toast.success(result.message);
                navigate('/');
            } else {
                toast.error(result.message);
            }
            reset();
        } catch (err) {
            const errorMessage = err?.response?.data?.message || err.message || "An unknown error occurred";
            toast.error(errorMessage);
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <Box sx={{ p: { md: 4, xs: '0 8px' }, width: { md: '75%', xs: '100%' }, m: 'auto' }}>
                <>
                    <Box component={'form'} onSubmit={handleSubmit(SubmitForm)}>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                            <Box sx={{ width: { md: '100%', xs: '100%' }, textAlign: 'start' }}>
                                <FormInput
                                    label={t("Full Name")}
                                    type={'name'}
                                    placeholder={'Enter Full Name'}
                                    value={name}
                                    required={true}
                                    onChange={(e) => setName(e.target.value)} />
                            </Box>
                            <Box sx={{ width: { md: '100%', xs: '100%' }, textAlign: 'start' }}>
                                <FormInput
                                    label={"Email"}
                                    type={'email'}
                                    value={email}
                                    required={true}
                                    placeholder={`Enter Email`}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </Box>
                            <Box sx={{ width: { md: '100%', xs: '100%' }, textAlign: 'start' }}  >
                                <FormInput
                                    type={'tel'}
                                    label={`Enter Phone Number`}
                                    placeholder={'01xxxxxxxxx'}
                                    required={true}
                                    selectedCountryCode={selectedCountryCode}
                                    setSelectedCountryCode={setSelectedCountryCode}
                                    phoneNumber={phoneNumber}
                                    setPhoneNumber={setPhoneNumber} />
                            </Box>
                            <Box sx={{ width: { md: '100%', xs: '100%' }, textAlign: 'start' }}  >
                                <FormInput label={`Password`}
                                    type={'password'}
                                    required={true}
                                    placeholder={`Enter Password`}
                                    name={'password'}
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)} />
                            </Box>
                            <Box sx={{ width: { md: '100%', xs: '100%' }, textAlign: 'start' }}  >
                                <FormInput label={`Confirm Password`} type={'password'}
                                    placeholder={`Re-enter Your Password`}
                                    required={true}
                                    name={'confirm_password'}
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)} />
                            </Box>
                        </Box>
                        <Box mt={2} textAlign={'center'}>
                            <Btn type='submit' width='50%' widthMob='90%' disabled={loading}>
                                {loading ? 'Loading...' : 'Register'}
                            </Btn>
                        </Box>
                    </Box>
                </>
            </Box>
        </>
    );
};

export default FormRegister;
